// extracted by mini-css-extract-plugin
export default {"navRight":"guestRightHeader_navRight__VC97Y","icon":"guestRightHeader_icon__RnV-+"};